import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import FavPages from './FavPages'
import Search from './Search'
import LanguageSwitcher from './LanguageSwitcher'
import Actions from './Actions'
import UserMenu from './UserMenu'
import style from './style.module.scss'


const TopBar = () => {
  return (
    <div className={style.topbar}>
      <div className="mr-4">
        <FavPages />
      </div>
      <div className="mr-auto">
        <Search />
      </div>
      <div className="mr-4 d-none d-md-block">
        <Link to="/add/property"> <Button type="primary">Add Property</Button></Link>
      </div>
      <div className="mb-0 mr-auto d-xl-block d-none">
        <Link to="/add/investor"> <Button type="primary">Add Investor</Button> </Link>
      </div>
      <div className="mr-4 d-none d-sm-block">
        <LanguageSwitcher />
      </div>
      <div className="mr-4 d-none d-sm-block">
        <Actions />
      </div>
      <div className="">
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
